import React from "react";
import { m as motion } from "../../shared/components/Motion";

const ContactFormInput = ({ label, type, name, placeholder }) => {
  // Generate a unique id for each input field
  const inputId = `${name}-input`;

  const inputVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 20 },
    },
  };

  return (
    <motion.div
      className="contact__form-div"
      variants={inputVariants}
      initial="hidden"
      animate="visible"
    >
      <label htmlFor={inputId} className="contact__form-tag">
        {label}
      </label>
      <input
        type={type}
        name={name}
        id={inputId} // Set the id attribute here
        placeholder={placeholder}
        className="contact__form-input"
        autoComplete={name}
        required
      />
    </motion.div>
  );
};

export default ContactFormInput;
